import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Support'}</title>
      <g xmlns="http://www.w3.org/2000/svg">
        <path
          d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z"
          fill="#BEEBF6"
        />
        <path
          d="M17.6667 33.0583L14.2 35.6583V30.4583H10.7333C9.77604 30.4583 9 29.6823 9 28.725V14.8583C9 13.901 9.77604 13.125 10.7333 13.125H29.8C30.7573 13.125 31.5333 13.901 31.5333 14.8583V20.0583"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.0586 24.623C16.1513 25.2013 17.3215 25.6193 18.5334 25.8641"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.9336 18.3252V20.0585"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5996 18.3252V20.0585"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.9995 33.9249H31.5328V39.1249L26.3328 33.9249H21.1328V23.5249H34.9995V33.9249Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.5993 28.2915C24.36 28.2915 24.166 28.4855 24.166 28.7248C24.166 28.9642 24.36 29.1582 24.5993 29.1582C24.8387 29.1582 25.0327 28.9642 25.0327 28.7248C25.0327 28.4855 24.8387 28.2915 24.5993 28.2915"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.0661 28.2915C27.8268 28.2915 27.6328 28.4855 27.6328 28.7248C27.6328 28.9642 27.8268 29.1582 28.0661 29.1582C28.3055 29.1582 28.4995 28.9642 28.4995 28.7248C28.4995 28.4855 28.3055 28.2915 28.0661 28.2915"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M31.5329 28.2915C31.2936 28.2915 31.0996 28.4855 31.0996 28.7248C31.0996 28.9642 31.2936 29.1582 31.5329 29.1582C31.7723 29.1582 31.9663 28.9642 31.9663 28.7248C31.9663 28.4855 31.7723 28.2915 31.5329 28.2915"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
